import { render, staticRenderFns } from "./ReturnRate.vue?vue&type=template&id=1b0c818b&scoped=true&"
import script from "./ReturnRate.vue?vue&type=script&lang=js&"
export * from "./ReturnRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0c818b",
  null
  
)

export default component.exports